<template>
  <div class="p-grid">
    <div class="p-col-12 p-d-flex p-justify-end">
      <back-button class="p-ml-2" />
    </div>
    <div class="p-col-12 p-text-center">
      <div style="font-size: 5rem">Under Construction</div>
    </div>
    <div class="p-col-12 p-text-center">
      <img src="img/under_construction.jpg" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BackButton from "@/components/BackButton.vue";

export default defineComponent({
  name: "UnderConstruction",
  components: { BackButton },
  //   setup() {},
});
</script>

<style></style>
